import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MilestoneDetail } from 'src/app/core/api.gen';

@Component({
  selector: 'eos-milestone-basic',
  templateUrl: './milestone-basic.component.html'
})
export class MilestoneBasicComponent implements OnInit {

  @Input() milestones: MilestoneDetail[] = [];
  @Input() onMilestoneClick: Function;

  constructor(public modal: NgbActiveModal) { }

  ngOnInit() {

  }

}
